"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Text = _interopRequireDefault(require("../Text/Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconCount = function IconCount(_ref) {
  var icon = _ref.icon,
      count = _ref.count,
      iconSize = _ref.iconSize,
      props = _objectWithoutPropertiesLoose(_ref, ["icon", "count", "iconSize"]);

  return (0, _themeUi.jsx)(_themeUi.Flex, _extends({}, props, {
    sx: {
      p: 1,
      justifyContent: 'center',
      alignItems: 'center'
    }
  }), (0, _themeUi.jsx)(_Icon["default"], {
    icon: icon,
    size: iconSize,
    sx: {
      color: 'inherit'
    }
  }), (0, _themeUi.jsx)(_Text["default"], {
    variant: "display",
    sx: {
      color: 'inherit',
      ml: 1
    }
  }, count));
};

IconCount.propTypes = {
  icon: _propTypes["default"].func.isRequired,
  count: _propTypes["default"].number,
  iconSize: _propTypes["default"].number
};
IconCount.defaultProps = {
  iconSize: 1
};
var _default = IconCount;
exports["default"] = _default;